<div class="card main-store-card container-fluid">

  <!-- Header -->
  <div class="row justify-content-between align-items-center mb-4">
    <div class="col-auto">
      <h3 class="m-0 font-bold text-muted">Mi Negocio</h3>
    </div>
    <div class="col-auto d-flex gap-2">
      <p-button
        label="Productos"
        icon="pi pi-box"
        routerLink="/admin/my-store/products"
        severity="secondary"
        [rounded]="true"
        size="small"
      />
      <p-button
        label="Editar"
        icon="pi pi-pencil"
        routerLink="/admin/my-store/edit"
        [rounded]="true"
        size="small"
      />
    </div>
  </div>

  @if (storeInfo) {
    <div class="store-banner"></div>

    <div class="store-profile-header">
      <div class="logo-container">
        @if (storeInfo.sto_logo_url) {
          <img src="{{ storeInfo.sto_logo_url }}" alt="Logo" class="store-logo-img" />
        } @else {
          <div class="store-logo-placeholder">
            {{ storeInfo.sto_name.slice(0, 2) }}
          </div>
        }
      </div>

      <div class="store-meta-info">
        <div class="d-flex align-items-center gap-2 flex-wrap mb-1">
          <h2 class="store-title m-0">{{ storeInfo.sto_name }}</h2>
          <span class="status-badge" [ngClass]="storeInfo.sto_store_status_id === 1 ? 'status-open' : 'status-closed'">
            {{ statusName }}
          </span>
        </div>
        <p class="store-description m-0">{{ storeInfo.sto_description || 'Sin descripción disponible' }}</p>
      </div>
    </div>

    <div class="container-fluid p-0 mt-4">
      <div class="row">

        <div class="col-lg-8 mb-4">

          <!-- Información básica -->
          <div class="detail-card">
            <div class="detail-card-title">
              <i class="pi pi-info-circle"></i> Información Básica y de Contacto
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <div class="info-row">
                  <div class="info-icon-wrapper icon-blue">
                    <i class="pi pi-phone"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label">Teléfono del Negocio</div>
                    <p class="info-value">{{ storeInfo.sto_phone || 'Sin teléfono' }}</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-row">
                  <div class="info-icon-wrapper icon-purple">
                    <i class="pi pi-align-left"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label">Descripción Comercial</div>
                    <p class="info-value text-muted">{{ storeInfo.sto_description || 'Sin descripción asignada' }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Ubicación y parámetros -->
          <div class="detail-card">
            <div class="detail-card-title">
              <i class="pi pi-map-marker"></i> Ubicación y Parámetros Comerciales
            </div>
            <div class="row mt-2">
              <div class="col-md-6">
                <div class="info-row">
                  <div class="info-icon-wrapper icon-orange">
                    <i class="pi pi-compass"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label">Dirección</div>
                    <p class="info-value font-bold">{{ storeInfo.sto_address || 'Sin dirección asignada' }}</p>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-icon-wrapper icon-blue">
                    <i class="pi pi-map"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label">Radio de Entrega</div>
                    <p class="info-value">{{ storeInfo.sto_delivery_radius_km }} km</p>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-row">
                  <div class="info-icon-wrapper icon-green">
                    <i class="pi pi-money-bill"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label">Tarifa de Envío</div>
                    <p class="info-value">${{ storeInfo.sto_delivery_fee }}</p>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-icon-wrapper icon-purple">
                    <i class="pi pi-shopping-bag"></i>
                  </div>
                  <div class="info-content">
                    <div class="info-label">Monto de Pedido Mínimo</div>
                    <p class="info-value">${{ storeInfo.sto_min_order_amount }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Horarios -->
          <div class="detail-card">
            <div class="detail-card-title mb-3">
              <i class="pi pi-clock"></i> Horarios de Funcionamiento
            </div>
            @if (storeInfo.schedules && storeInfo.schedules.length > 0) {
              <p-table [value]="storeInfo.schedules" styleClass="p-datatable-sm p-datatable-striped">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Día</th>
                    <th>Estado</th>
                    <th>Hora Apertura</th>
                    <th>Hora Cierre</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-schedule>
                  <tr>
                    <td class="font-bold">{{ getDayName(schedule.ssh_day_of_week) }}</td>
                    <td>
                      <span class="status-badge" [ngClass]="schedule.ssh_is_open ? 'status-open' : 'status-closed'">
                        {{ schedule.ssh_is_open ? 'Abierto' : 'Cerrado' }}
                      </span>
                    </td>
                    <td><i class="pi pi-clock text-muted mr-1"></i> {{ schedule.ssh_open_time }}</td>
                    <td><i class="pi pi-clock text-muted mr-1"></i> {{ schedule.ssh_close_time }}</td>
                  </tr>
                </ng-template>
              </p-table>
            } @else {
              <div class="text-center py-4 text-muted">
                <i class="pi pi-calendar-times d-block mb-2" style="font-size: 2.5rem; color: var(--text-color-secondary);"></i>
                <p class="m-0">Sin horarios configurados en este negocio</p>
              </div>
            }
          </div>
        </div>

        <!-- Solo lectura: lo administra la plataforma -->
        <div class="col-lg-4 mb-4">
          <div class="detail-card">
            <div class="detail-card-title">
              <i class="pi pi-lock"></i> Administrado por la plataforma
            </div>
            <p class="text-muted small mb-3">Estos datos solo los modifica el administrador de la plataforma.</p>
            <div class="status-label-indicator d-flex mb-3">
              <span class="text-muted">Estado:</span>
              <span class="status-badge" [ngClass]="storeInfo.sto_store_status_id === 1 ? 'status-open' : 'status-closed'">
                {{ statusName }}
              </span>
            </div>
            <div class="status-label-indicator d-flex mb-0">
              <span class="text-muted">Negocio destacado:</span>
              <span class="status-badge" [ngClass]="storeInfo.sto_is_featured ? 'status-open' : 'status-closed'">
                {{ storeInfo.sto_is_featured ? 'Sí' : 'No' }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  } @else if (loading) {
    <div class="d-flex flex-column align-items-center justify-content-center py-5">
      <i class="pi pi-spin pi-spinner text-primary mb-3" style="font-size: 3rem"></i>
      <p class="text-muted font-bold">Cargando información del negocio...</p>
    </div>
  } @else {
    <div class="d-flex flex-column align-items-center justify-content-center py-5">
      <i class="pi pi-exclamation-triangle text-danger mb-3" style="font-size: 3rem"></i>
      <p class="text-muted font-bold">{{ errorMessage }}</p>
      <p-button label="Reintentar" icon="pi pi-refresh" (onClick)="getStore()" [rounded]="true" size="small" />
    </div>
  }
</div>
